import type { GraphDto } from "@station/data/dto/graph.dto";
import { GraphDtoSchema } from "@station/data/dto/graph.dto";
import { Graph } from "@station/domain/models/graph.model.ts";
import { injectable } from "inversify";

@injectable()
export class GraphMapper {
    map(graphDto: GraphDto): Graph[] {
        const graphParsed = GraphDtoSchema.safeParse(graphDto);

        if (!graphParsed.success) {
            console.error(graphParsed.error.issues);
            return [];
        }

        const readingsByTimestamp = new Map<number, Record<string, number>>();

        Object.entries(graphParsed.data).forEach(
            ([sensorId, sensorDataArray]) => {
                sensorDataArray.forEach((sensorData) => {
                    const name = sensorData[0];
                    const existingEntry = readingsByTimestamp.get(name);

                    const value = sensorData[1];

                    if (existingEntry) {
                        existingEntry[sensorId] = value;
                    } else {
                        readingsByTimestamp.set(name, {
                            [sensorId]: value,
                        });
                    }
                });
            },
        );

        return [...readingsByTimestamp.entries()]
            .sort(
                ([firstTimestamp], [secondTimestamp]) =>
                    firstTimestamp - secondTimestamp,
            )
            .mapNotNull(([timestamp, yAxisValues]) =>
                Graph.create({
                    name: timestamp.toString(),
                    yAxisValues,
                }).unwrapOr(null),
            );
    }
}
